import {  Save, Info, BuildCircle,  } from "@mui/icons-material";
import dayjs from '../../utils/dayjs-setup';
import { Button, Chip, GridLegacy as Grid, IconButton, Input, List, ListItem, ListItemText, Table, TableRow, TableHead, TableBody, TableCell, TableContainer, TextField, Tooltip, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Menu, MenuItem, InputAdornment } from '@mui/material';
import { useState, useEffect, useContext, useRef } from "react";
import { ActionTypes, AppContext } from "../../store/AppStore";
import { AxiosInstance,  DateFormatString,  DialogType, FormatPrice,isIntNumber, parseNumber, } from "../../utils/constants";
import * as yup from "yup";
import {  InputWithLabel } from "../../components/form/custom-imputs"
import {  SubItemTableComprasProductos, } from "../../components/table/table-components";
import { FilterForm } from "../../components/form/filter-form";
import { useNavigate, useParams } from "react-router-dom";
import { green, red } from "@mui/material/colors";
import { ModalNegociacion } from "../../components/modals/modal-negociacion";

const schemaFilter = yup.object({
  

}).required();



const getNecesidadUmLabel = (col)=>{
  return col?.nombre_corto_unidad_necesidad || col?.nombre_unidad_necesidad || '';
}

const getNecesidadQty = (col)=>{
  return Number(col?.total_necesidad_um ?? col?.cant_unidad ?? 0);
}

const getCompradoUm = (col)=>{
  return Number(col?.total_comprado_um ?? 0);
}

const getRutaCantidadUm = (ruta)=>{
  if (!ruta) return 0;
  const um = Number(ruta.total_comprado_um);
  if (!Number.isNaN(um) && um > 0) {
    return um;
  }
  const kg = Number(ruta.total_comprado || 0);
  if (kg <= 0) {
    return Number.isNaN(um) ? 0 : um;
  }
  const peso = Number(ruta.peso_necesidad || 0);
  return peso > 0 ? kg / peso : kg;
}

const getCantidadOfertadaUm = (item)=>{
  const converted = Number(item?.cantidad_ofertada_um);
  if (!Number.isNaN(converted) && converted > 0) {
    return converted;
  }
  const qty = Number(item?.cotizacion_cantidad || 0);
  if (qty <= 0) {
    return 0;
  }
  const pesoQuote = Number(item?.prod_conversion_peso || 0);
  const pesoNeed = Number(item?.peso_necesidad || 0);
  if (pesoQuote > 0 && pesoNeed > 0) {
    return qty * (pesoQuote / pesoNeed);
  }
  return qty;
}

const excedeDisponibleCotizacion = (item)=>{
  const compradoUm = (item?.cotizacion_rutas || []).reduce((acum, ruta)=>acum + getRutaCantidadUm(ruta), 0);
  const disponibleUm = Number(item?.total_disponible_um);
  if (Number.isNaN(disponibleUm)) {
    return false;
  }
  return compradoUm > disponibleUm;
}

const getPrecioUm = (item)=>{
  const converted = Number(item?.precio_um);
  if (!Number.isNaN(converted) && converted > 0) {
    return converted;
  }
  const precio = Number(item?.cotizacion_precio_un || 0);
  if (precio <= 0) {
    return 0;
  }
  const pesoQuote = Number(item?.prod_conversion_peso || 0);
  const pesoNeed = Number(item?.peso_necesidad || 0);
  if (pesoQuote > 0 && pesoNeed > 0) {
    return precio * (pesoNeed / pesoQuote);
  }
  return precio;
}

const recomputeNecesidadComprado = (necesidades=[], cotizaciones=[])=>{
  return necesidades.map(nec=>{
    const rutasMunicipio = cotizaciones.flatMap(cot=>
      (cot.cotizacion_rutas || []).filter(ruta=>String(ruta.destino) === String(nec.cod_municipio))
    );
    const totalCompradoUm = rutasMunicipio.reduce((acum,ruta)=>acum + getRutaCantidadUm(ruta), 0);
    const totalCompradoKg = rutasMunicipio.reduce((acum,ruta)=>acum + Number(ruta.total_comprado || 0), 0);
    return {
      ...nec,
      total_comprado: totalCompradoKg,
      total_comprado_um: totalCompradoUm
    };
  });
}

const HeaderRenderCustom = ({value,setOpenedModalConfig,...props})=>{
  const unidadLabel = getNecesidadUmLabel(props.colsDetalle?.[0]) || 'UM';
  return  <Table  >  
     <TableHead  >
        <TableRow>
          {props.colsDetalle.map( col=> {
            const necesidadUm = getNecesidadQty(col);
            const compradoUm = getCompradoUm(col);
            return <TableCell sx={{minWidth:'120px'}} key={col.cod_municipio} >

          <Grid container >
            <Grid sm={6} sx={6} md={6} >
            {col.descripcion}
          </Grid>
            <Grid sm={3} sx={3} md={3} >
              <Tooltip title={`cantidad faltante ${FormatPrice(necesidadUm-compradoUm)} ${getNecesidadUmLabel(col)}` } placement="top" >
                  <Chip label={FormatPrice(compradoUm)+'/'+FormatPrice(necesidadUm)}  color='primary' variant="outlined" />
              </Tooltip>
            </Grid>
         

          </Grid>
           
           </TableCell>
          })}
        </TableRow>
        <TableRow>
          {props.colsDetalle.map( col=> <TableCell sx={{minWidth:'120px'}} key={col.cod_municipio} >
            <Table>
              <TableBody>
                  <TableRow>
                      <TableCell sx={{border:"none",minWidth:'120px'}} >Precio {unidadLabel}</TableCell>
                      <TableCell  sx={{border:"none",minWidth:'120px'}} >Comprado</TableCell>
                      <TableCell sx={{border:"none",minWidth:'120px'}} >Accion</TableCell>
                  </TableRow>
              </TableBody>
            </Table>
           
           </TableCell>
           
           )}
        </TableRow>
       
     </TableHead>
  </Table>

}



const ActionContextMenu = (props)=>{
  
  const [anchoorElement,setAnchoorElement] = useState(null);
  const open = Boolean(anchoorElement);
  const handleClick = (event) => {
  setAnchoorElement(event.currentTarget);
    
  };
  const handleClose = (type_action) => {
  setAnchoorElement(null);
  if ( type_action === 'wap_message'){
    window.open(`https://wa.me/57${props.item.celular}`,"_blank");
}
if ( type_action === 'up_negociation'){
  props.openConfigNegociacion(props.item.cotizacion_cod,["CONFIRMADO","PRECONFIRMADO"].includes(props.item?.estado_cesta))
}
  };


  return <div>
  <Button
    id="basic-button"
    aria-controls={open ? 'basic-menu' : undefined}
    aria-haspopup="true"
    aria-expanded={open ? 'true' : undefined}
    onClick={handleClick}
    variant="contained"
    size="small"
    color="secondary"
  >
    Acciones
  </Button>
  <Menu
    id="basic-menu"
    anchorEl={anchoorElement}
    open={open}
    onClose={handleClose}
    MenuListProps={{
      'aria-labelledby': 'basic-button',
    }}
  >
    <MenuItem onClick={e=>handleClose("wap_message")}>Escribir</MenuItem>
    <MenuItem onClick={e=>handleClose("up_negociation")}>Redactar negociación</MenuItem>
   
  </Menu>
</div>

}


const tableSizeSaveKey = "Necesidades-tableSizeSaveKey";
export const ComprasProductos = (props) => {

  const [dataSetProdctos, setDataSetProductos] = useState([]);
  const { dispatch, store } = useContext(AppContext);
  const {cod_producto,fecha_entrega,cod_unidad_medida} = useParams();
  const [productoInfo,setProductInfo] = useState({});
  const [necesidad,setNecesidad] = useState([]);
  const [dialogObservaciones,setDialogObservaciones] = useState({});
  const [dialogConfirmacionParcial,setDialogConfirmacionParcial] = useState({
    isVisible:false,
    message:"",
    limitsOverload:{
      ind_cubierta:false,
      ind_sobrecomprado:false
    }
  });
  const [currentConfig,setCurrentConfig] = useState({});
  const [openedModal, setOpenedModal] = useState(false);
  const [tableSize,setTableSize] = useState(localStorage.getItem(tableSizeSaveKey) || 450 );
  const [configModalNegociacion,setConfigModalNegociacion] = useState({});
  
  const navigation = useNavigate();

  const formRef = useRef();


  useEffect(() => {
 
    loadItems(true);
  }, []);
  const loadItems = async (loading = true) => {
    setDataSetProductos([]);
    setProductInfo({});
    if (loading) {
      dispatch({
        type: ActionTypes.setLoadingPage,
        data: true
      });
    }

    let { data: { value } } = await AxiosInstance.post("necesidades/obtener-detalle-necesidad", {
      cod_producto,
      fecha_entrega,
      cod_unidad_medida
    });
    const unidadNecesidad = value.unidad_necesidad || {};
    const nombreCortoUm = unidadNecesidad.nombre_corto || value.necesidad?.[0]?.nombre_corto_unidad_necesidad || '';
    const necesidadConComprado = recomputeNecesidadComprado(value.necesidad, value.cotizaciones);
    const necesidadTotal = necesidadConComprado.reduce((acumulador,currentDat)=>acumulador+Number(currentDat.total_necesidad_um ?? currentDat.cant_unidad),0);
    const totalComprado = necesidadConComprado.reduce((acumulador,currentDat)=>acumulador+Number(currentDat.total_comprado_um || 0),0);
    const necesidadPendiente = necesidadTotal - totalComprado;
    const porcentaje_comprado = necesidadTotal ? ( totalComprado * 100 )/necesidadTotal : 0;
    setProductInfo({
      nombre_producto:value.producto.descripcion,
      necesidad_total:necesidadTotal,
      calidad:value.producto?.calidad_producto?.descripcion,
      necesidad_pendiente:necesidadPendiente < 0?0:necesidadPendiente,
      cod_erp_item:value.producto.cod_erp,
      total_comprado:totalComprado,
      porcentaje_sobrecompra:value.producto?.porcentaje_sobrecompra || 0,
      porcentaje_comprado:porcentaje_comprado+ "%",
      cant_unidad:nombreCortoUm || unidadNecesidad.nombre,
      nombre_corto_unidad_necesidad:nombreCortoUm,
      peso_necesidad:unidadNecesidad.peso
    });
    setNecesidad(necesidadConComprado);
    setDataSetProductos(value.cotizaciones);






    dispatch({
      type: ActionTypes.setLoadingPage,
      data: false
    });

  }
  const getIdInput = (parentIndex,child_index)=>{
    return `${parentIndex}-${child_index}`;
  }

  const updateTotalesDesdeNecesidad = (necesidadesActualizadas)=>{
    const necesidadTotalUm = necesidadesActualizadas.reduce((acum,item)=>acum+Number(item.total_necesidad_um ?? item.cant_unidad ?? 0),0);
    const totalCompradoUm = necesidadesActualizadas.reduce((acum,item)=>acum+Number(item.total_comprado_um || 0),0);
    const pendiente = necesidadTotalUm - totalCompradoUm;
    setProductInfo(prev=>({
      ...prev,
      necesidad_total:necesidadTotalUm,
      total_comprado:totalCompradoUm,
      necesidad_pendiente:pendiente < 0?0:pendiente,
      porcentaje_comprado:(necesidadTotalUm ? (totalCompradoUm * 100)/necesidadTotalUm : 0)+"%"
    }));
  }

  const onChangeCantidad = (parentIndex, childIndex, cantidadKg, cantidadUm)=>{
    setDataSetProductos(prevCots=>{
      const nextCots = prevCots.map((cot, i)=>{
        if (i !== parentIndex) return cot;
        return {
          ...cot,
          cotizacion_rutas: cot.cotizacion_rutas.map((ruta, j)=>
            j === childIndex
              ? { ...ruta, total_comprado: cantidadKg, total_comprado_um: cantidadUm, ind_cambio_sin_guardar: true }
              : ruta
          )
        };
      });
      setNecesidad(prevNec=>{
        const nextNec = recomputeNecesidadComprado(prevNec, nextCots);
        updateTotalesDesdeNecesidad(nextNec);
        return nextNec;
      });
      return nextCots;
    });
  }


const onSaveProductInput = async(child_index,parent_index,propsData)=>{
  console.log({
    props,child_index,parent_index
  });
   const compraData = {...propsData.dataForm[child_index]};
   const InputValue = compraData.cantidad || 0;
   let newDatasetProduct = [];
   newDatasetProduct = [...dataSetProdctos];
   let valorEnviado =  parseNumber(InputValue );
    if ( isIntNumber(valorEnviado)  || Number(valorEnviado) < 0  ){
      dispatch({
        type: ActionTypes.setModalInfo,
        data: {
          title: "Advertencia",
          message: "El numero digitado no es valido",
          type: DialogType.peligro,
          isVisible: true
        }
      });
      return;
    }

    let result =  Object.values(compraData).some(valueForm=>{
        console.log({ valueForm,compraData });
      return [null,undefined].includes(valueForm);
    });

    if ( result ){
      dispatch({
        type: ActionTypes.setModalInfo,
        data: {
          title: "Advertencia",
          message: "Debe llenar la configuracion de la orden de compra",
          type: DialogType.peligro,
          isVisible: true
        }
      });
      return ;
    }


 
    newDatasetProduct[parent_index].cotizacion_rutas[child_index].total_comprado = Number(valorEnviado);
    newDatasetProduct[parent_index].cotizacion_rutas[child_index].total_comprado_um = Number(compraData.cantidad_um || 0);
    newDatasetProduct[parent_index].cotizacion_rutas[child_index].ind_cambio_sin_guardar = false;

    let payload = {
      cod_producto:newDatasetProduct[parent_index].codigo_producto,
      cod_cotizacion:newDatasetProduct[parent_index].cotizacion_cod,
      fecha_entrega:fecha_entrega,
      cod_unidad_medida:newDatasetProduct[parent_index].cotizacion_un_md,
      cod_municipio:newDatasetProduct[parent_index].cotizacion_rutas[child_index].destino,
      cantidad:valorEnviado,
      bodega:compraData.bodega?.value,
      centro_operacion:compraData.centro_operacion?.value,
      precio_unitario:newDatasetProduct[parent_index].cotizacion_rutas[child_index].valor_total_prod,
      fecha_entrega_oc:dayjs(compraData.fecha_entrega).format(DateFormatString),
      tipo_origen_compra:"NECESIDAD"
    };
    //console.log({payload});
    dispatch({
      type: ActionTypes.setLoadingPage,
      data: true
    });
    try{
      
      let result  = await  AxiosInstance.post("necesidades/actualizar-carrito-compras",payload);
      loadItems(false);
    }catch(e){
      dispatch({
        type: ActionTypes.setLoadingPage,
        data: false
      });
      dispatch({
        type: ActionTypes.setModalInfo,
        data: {
          title: "Error",
          message: "Error de comunicacion verifique su conexion a internet",
          type: DialogType.peligro,
          isVisible: true
        }
      });
    }
  

 


}

const openConfigNegociacion = (cod_cotizacion,disabled)=>{
  setConfigModalNegociacion({
    cod_cotizacion,
    opened:true,
    isLoked:disabled
  });
}

const ObserVacionesDialogComponent = ()=><Dialog
 open={dialogObservaciones.isVisible}

>
  <DialogTitle>Observaciones</DialogTitle>
  <DialogContent><Typography justifyContent={"start"} variant="p" >{dialogObservaciones.text}</Typography></DialogContent>
  <DialogActions sx={{alignItems:"center",justifyContent:"center"}} >
    <Button onClick={e=>setDialogObservaciones({})} variant="contained" size="sm" color="primary"  >OK</Button>
  </DialogActions>
</Dialog>

const cerrarDialogConfirmacionParcial = ()=>{
  setDialogConfirmacionParcial({
    isVisible:false,
    message:"",
    limitsOverload:{
      ind_cubierta:false,
      ind_sobrecomprado:false
    }
  });
}

const ConfirmacionParcialDialogComponent = ()=><Dialog
  open={Boolean(dialogConfirmacionParcial.isVisible)}
  onClose={cerrarDialogConfirmacionParcial}
>
  <DialogTitle>Confirmación parcial</DialogTitle>
  <DialogContent>
    <Typography variant="body1">{dialogConfirmacionParcial.message}</Typography>
  </DialogContent>
  <DialogActions sx={{alignItems:"center",justifyContent:"flex-end"}} >
    <Button onClick={cerrarDialogConfirmacionParcial} variant="outlined" color="secondary">Cancelar</Button>
    <Button
      onClick={()=>{
        const limitsOverload = dialogConfirmacionParcial.limitsOverload;
        cerrarDialogConfirmacionParcial();
        enviarPreconfirmacion(limitsOverload);
      }}
      variant="contained"
      color="warning"
    >
      Preconfirmar parcialmente
    </Button>
  </DialogActions>
</Dialog>



const columnsTable = [
  {

    key: "cotizacion_cod",
    keyValue: "cotizacion_cod",
    label: "ID",
    headerRender: (props) => props.label,
    bodyRender: (props) => `${props.value}`,
    typeRow: "string",
    sort: false,
    sortFunction: () => { },
    sortStatus: "",

  },
  {

    key: "razon_social",
    keyValue: "razon_social",
    label: "Razon Social",
    headerRender: (props) => props.label,
    bodyRender: (props) => <>
    {props.item.estado_usuario === 'POR CONFIRMAR'?  <Tooltip title='El proveedor no se encuentra habilitado para vender productos'  ><p  style={{color:props.item.estado_usuario === 'POR CONFIRMAR'?red[500]:"black"}}  ><p>{props.value}</p></p></Tooltip>:
    <>
     <p>{props.value}</p> 
    </>
    }
    </> ,
    typeRow: "string",
    sort: false,
    sortFunction: () => { },
    sortStatus: "",

  },
  {
    key: "cotizacion_cod",
    keyValue: "cotizacion_cod",
    label: "Eventos",
    headerRender: (props) => props.label,
    bodyRender:props=><ActionContextMenu {...props} openConfigNegociacion={openConfigNegociacion} />, 
    typeRow: "string",
    sort: false,
    sortFunction: () => { },
    sortStatus: "",
  },

  {

    key: "cotizacion_origen_name",
    keyValue: "cotizacion_origen_name",
    label: "Origen/Sucursal",
    headerRender: (props) => props.label,
    bodyRender: (props) => `${props.value}`,
    typeRow: "string",
    sort: false,
    sortFunction: () => { },
    sortStatus: "",

  },
  {

    key: "cotizacion_destino_name",
    keyValue: "cotizacion_destino_name",
    label: "Lugar de entrega",
    headerRender: (props) => props.label,
    bodyRender: (props) => props.value || 'Recoger en finca',
    typeRow: "string",
    sort: false,
    sortFunction: () => { },
    sortStatus: "",

  },
  {

    key: "nombre_producto",
    keyValue: "nombre_producto",
    label: "Producto",
    headerRender: (props) => props.label,
    bodyRender: (props) => props.value,
    typeRow: "string",
    sort: false,
    sortFunction: () => { },
    sortStatus: "",

  },
  {

    key: "cotizacion_cantidad",
    keyValue: "cotizacion_cantidad",
    label: "Cantidad ofertada",
    headerRender: (props) => props.label,
    bodyRender: (props) =>FormatPrice(getCantidadOfertadaUm(props.item))+" "+(props?.item?.nombre_corto_unidad_necesidad || ''),
    typeRow: "number",
    sort: false,
    sortFunction: () => { },
    sortStatus: "",

  },
  {

    key: "cotizacion_precio_un",
    keyValue: "cotizacion_precio_un",
    label: productoInfo.nombre_corto_unidad_necesidad ? `Precio/${productoInfo.nombre_corto_unidad_necesidad}` : "Precio/Und",
    headerRender: (props) => props.label,
    bodyRender: (props) =>FormatPrice(getPrecioUm(props.item)),
    typeRow: "number",
    sort: false,
    sortFunction: () => { },
    sortStatus: "",

  },   
  {

    key: "total_disponible",
    keyValue: "total_disponible",
    label: "Total Disponible",
    headerRender: (props) => props.label,
    bodyRender: ({item}) =>{
      const excedeDisponible = excedeDisponibleCotizacion(item);
      const label = `${FormatPrice(Number(item.total_disponible_um).toFixed(2))} ${item.nombre_corto_unidad_necesidad || ''}`;
      const contenido = <Typography component="span" sx={{ color: excedeDisponible ? red[500] : 'inherit', fontWeight: excedeDisponible ? 700 : 400 }}>{label}</Typography>;
      if (!excedeDisponible) {
        return contenido;
      }
      return <Tooltip title="Esta superando la cantidad disponible del producto" placement="top">{contenido}</Tooltip>;
    },
    typeRow: "number",
    sort: false,
    sortFunction: () => { },
    sortStatus: "",

  },
  {

    key: "cotizacion_rutas",
    keyValue: "cotizacion_rutas",
    colsDetalle:necesidad,
    label: "Rutas calc",

    headerRender: (props) =><HeaderRenderCustom {...props} 
    setOpenedModalConfig={setOpenModalCurrentData} />,
    bodyRender: (props) => <SubItemTableComprasProductos
    onSaveProductInput={onSaveProductInput}
    onChangeCantidad={onChangeCantidad}
     removeHeader={true}
      cols={[{
        label: "valor total prod",
        valueKey: "valor_total_prod",
        keyRow: "valor_total_prod",
        CustomRender:({extraData,value})=><Tooltip  placement="bottom-start" 
        title={<>
      
         <List>
         <ListItem  >
            <ListItemText primary={`Precio base: ${FormatPrice(extraData.total_base_um ?? extraData.total_base_kg)}`} />
          </ListItem>
          {
            extraData?.detalle_sobre_costo?.map( dt=> 
            <ListItem key={dt.cod_sobrecosto || dt.cod} >
              <ListItemText primary={`${dt.nombre_sobrecosto}: $ ${FormatPrice(Number(dt.valor_sobrecosto))}`} />
            </ListItem> )
           
          }
           <ListItem  >
            <ListItemText primary={`Valor total: ${FormatPrice(Number(extraData.valor_total_prod_um ?? extraData.valor_total_prod))}`} />
          </ListItem>
          
         
         </List>
        </>} >
       
          <Chip color={ extraData.first_value?'success':'default' } label={`$ ${FormatPrice(extraData.valor_total_prod_um ?? value)}`} />
        </Tooltip>
      
       
      },
      {
        label: "total comprado",
        valueKey: "total_comprado",
        keyRow: "total_comprado",
        CustomRender:({child_index,parentIndex,dataForm,onChangeForm ,...props})=>{
          console.log({child_index,parentIndex,dataForm,onChangeForm ,props});
          return <Input
          dataForm={dataForm}
          endAdornment={<InputAdornment position="end" >{props?.extraData?.nombre_corto_unidad_necesidad || props?.parentData?.nombre_corto_unidad_necesidad}</InputAdornment>}
          type="number"
          sx={{minWidth:'100px'}}
          disabled={  ["CONFIRMADO","PRECONFIRMADO"].includes(props.extraData.estado_cesta) || props?.parentData?.estado_usuario === 'POR CONFIRMAR'}
          id={getIdInput(parentIndex,child_index)}
          value={dataForm[child_index]?.cantidad_um ?? ''}
          onChange={e=>onChangeForm(child_index,"cantidad_um",e.target.value,)}
          size='small' />;
        } 
       
      },
      {
        label: "accion",
        valueKey: "accion",
        keyRow: "accion",
        CustomRender:({child_index,parentIndex,onOpenDialog ,...props})=>[
          <IconButton type="button"  disabled={["CONFIRMADO","PRECONFIRMADO"].includes(props.extraData?.estado_cesta)} onClick={e=>onSaveProductInput(child_index,parentIndex,props)}  ><Save color="primary" /></IconButton>,
          <IconButton type="button"  onClick={e=>setDialogObservaciones({isVisible:true,text:props.parentData.cotizacion_observaciones})}  ><Info color="warning" /></IconButton>,
          <IconButton type="button"  onClick={e=>onOpenDialog(child_index)}  color="primary" > <BuildCircle /> </IconButton>,
         
         
        ]
       
      }
      ]}
      typeView="horizontal"
      items={props.value}  {...props} />,
    typeRow: "string",
    sort: false,
    sortFunction: () => { },
    sortStatus: "",

  },

];






const InputFilters = [
  {
    grid:{
      xs:2,
      md:2,
      sm:2
    },
    InputComponent:InputWithLabel,
    keyValue:"cod_erp_item",
    InputComponentProps:{
      label:"Cod ERP",
      fullWidth:true,
      disabled:true,
      size:"small",
    }
  },
{
  grid:{
    xs:4,
    md:4,
    sm:4
  },
  InputComponent:InputWithLabel,
  keyValue:"nombre_producto",
  InputComponentProps:{
    label:"Nombre",
    fullWidth:true,
    size:"small",
    disabled:true
  }
},
{
  grid:{
    xs:2,
    md:2,
    sm:2
  },
  InputComponent:InputWithLabel,
  keyValue:"calidad",
  InputComponentProps:{
    label:"Calidad",
    fullWidth:true,
    size:"small",
    disabled:true
  }
},{
  grid:{
    xs:2,
    md:2,
    sm:2
  },
  InputComponent:InputWithLabel,
  keyValue:"cant_unidad",
    InputComponentProps:{
      label:"Unidad de compra",
    fullWidth:true,
    size:"small",
    disabled:true
  }
},
{
  grid:{
    xs:3,
    md:3,
    sm:3
  },
  InputComponent:InputWithLabel,
  keyValue:"necesidad_total",
  format:FormatPrice,
  InputComponentProps:{
    label: productoInfo.nombre_corto_unidad_necesidad ? `Necesidad total (${productoInfo.nombre_corto_unidad_necesidad})` : "Necesidad total",
    fullWidth:true,
    size:"small",
    disabled:true
  }
},

{
  grid:{
    xs:3,
    md:3,
    sm:3
  },
  InputComponent:InputWithLabel,
  keyValue:"necesidad_pendiente",
  format:FormatPrice,
  InputComponentProps:{
    label: productoInfo.nombre_corto_unidad_necesidad ? `Necesidad pendiente (${productoInfo.nombre_corto_unidad_necesidad})` : "Necesidad pendiente",
    fullWidth:true,
    disabled:true,
    size:"small",
  }
},
{
  grid:{
    xs:3,
    md:3,
    sm:3
  },
  InputComponent:InputWithLabel,
  keyValue:"total_comprado",
  format:FormatPrice,
  InputComponentProps:{
    label: productoInfo.nombre_corto_unidad_necesidad ? `Total pedido (${productoInfo.nombre_corto_unidad_necesidad})` : "Total pedido",
    fullWidth:true,
    disabled:true,
    size:"small",
  }
},
{
  grid:{
    xs:3,
    md:3,
    sm:3
  },
  InputComponent:InputWithLabel,
  keyValue:"porcentaje_comprado",
  format:FormatPrice,
  InputComponentProps:{
    label:"Porcentaje comprado",
    fullWidth:true,
    disabled:true,
    size:"small",
  }
}
];



const enviarPreconfirmacion = (limitsOverload)=>{
  dispatch({
    type: ActionTypes.setLoadingPage,
    data: true
  });

  AxiosInstance.post("necesidades/confirmar-ordenes-cesta",{
    cod_producto,
    fecha_entrega,
    cod_unidad_medida,
    ...limitsOverload,
  }).then(result=>{

    if (result.data.status){
      dispatch({
        type: ActionTypes.setModalInfo,
        data: {
          title: limitsOverload?.ind_cubierta ? "Ordenes Preconfirmadas" : "Ordenes Preconfirmadas parcialmente",
          message: limitsOverload?.ind_cubierta
            ? "Sus ordenes se han preconfirmado, Por favor confirmelas para poder generar los documentos "
            : "Sus ordenes se han preconfirmado de forma parcial. La necesidad no quedo cubierta por completo. Confirmelas para generar los documentos.",
          type: DialogType.exitoso,
          isVisible: true
        }
      });
    }else{
      dispatch({
        type: ActionTypes.setModalInfo,
        data: {
          title: "Error al confirmar Ordenes",
          message: result.data.msg,
          type: DialogType.informativo,
          isVisible: true
        }
      });
    }
    loadItems(false);

  }).catch(err=>{

    dispatch({
      type: ActionTypes.setModalInfo,
      data: {
        title: "Error",
        message: "Error de comunicacion verifique su conexion a internet",
        type: DialogType.peligro,
        isVisible: true
      }
    });

  }).finally(()=>{
    dispatch({
      type: ActionTypes.setLoadingPage,
      data: false
    });
  });
}

const ConfirmarOrdenesCompra = ()=>{
 let messageList = "";
dataSetProdctos.forEach( item=>{
     item.cotizacion_rutas.forEach( ( destino )=>{
        if ( destino.total_comprado > 0 && destino.bodega_cod === null ){
          messageList += `La compra para ${destino.destino_nombre} en la cotizacion N° ${item.cotizacion_cod} no tiene una bodega configurada \n\n`;
        }
     } );
} );
if ( messageList.length > 0 ){
  dispatch({
    type: ActionTypes.setModalInfo,
    data: {
      title: "Error de configuracion",
      message: messageList,
      type: DialogType.peligro,
      isVisible: true
    }
  });
  return 
}
 
 const hayCantidadesSinGuardar = dataSetProdctos.some(item=>
    (item.cotizacion_rutas || []).some(ruta=>ruta.ind_cambio_sin_guardar && getRutaCantidadUm(ruta) > 0)
  );
  if (hayCantidadesSinGuardar){
    dispatch({
      type: ActionTypes.setModalInfo,
      data: {
        title: "Advertencia",
        message: "Debe guardar las cantidades (icono de disco) antes de preconfirmar",
        type: DialogType.peligro,
        isVisible: true
      }
    });
    return;
  }

 let totalOrdenConfirm =  dataSetProdctos.reduce((count,item)=>{
    let iternalSum = 0;
    item.cotizacion_rutas.forEach(ruta=>{
      iternalSum += getRutaCantidadUm(ruta);
    });
    return iternalSum + count;
  },0);
  let {necesidad_total,porcentaje_sobrecompra} = productoInfo;
  necesidad_total = Number(necesidad_total);
  porcentaje_sobrecompra = Number(porcentaje_sobrecompra);


  let limitsOverload = {
    ind_cubierta:false,
    ind_sobrecomprado:false
  }
  if( totalOrdenConfirm >= necesidad_total ){
      limitsOverload.ind_cubierta = true;
     if ( totalOrdenConfirm > necesidad_total ){
      limitsOverload.ind_sobrecomprado = true;
     }
  }
 
  let totalAllowed = necesidad_total * (porcentaje_sobrecompra/100) + necesidad_total ;

  const unidadLabel = productoInfo.nombre_corto_unidad_necesidad || 'UM';
  if ( totalOrdenConfirm <= 0 ){
    dispatch({
      type: ActionTypes.setModalInfo,
      data: {
        title: "Error",
        message: "No hay cantidades guardadas para preconfirmar",
        type: DialogType.peligro,
        isVisible: true
      }
    });
    return ;
  }

  if ( totalOrdenConfirm > totalAllowed + 0.5 ){

    dispatch({
      type: ActionTypes.setModalInfo,
      data: {
        title: "Error",
        message: `Esta superando el porcentaje de sobrecompra del producto (${FormatPrice(totalOrdenConfirm)} de ${FormatPrice(totalAllowed)} ${unidadLabel} permitidos). Verifique la compra`,
        type: DialogType.peligro,
        isVisible: true
      }
    });
  return ;
  }

  if ( totalOrdenConfirm < necesidad_total - 0.5 ){
    setDialogConfirmacionParcial({
      isVisible:true,
      limitsOverload,
      message: `La compra no cubre la necesidad completa (${FormatPrice(totalOrdenConfirm)} de ${FormatPrice(necesidad_total)} ${unidadLabel}). Si continúa, las órdenes se preconfirmarán de forma parcial y la necesidad quedará sin cubrir. ¿Desea continuar?`
    });
    return ;
  }

  enviarPreconfirmacion(limitsOverload);

}



const setOpenModalCurrentData = (cotizacion,ruta,child_index)=>{

  setCurrentConfig({
    centro_operacion:ruta.centro_op_cod?{value:ruta.centro_op_cod,ruta,label:ruta.centro_op_nombre}:undefined,
    bodega:ruta.bodega_cod?{value:ruta.bodega_cod,label:ruta.bodega_nombre}:null,
   
    fecha_entrega: ruta.fecha_entrega?dayjs(ruta.fecha_entrega):null

});

  setOpenedModal(true); 

}


const saveScreenSize = ()=>{
  localStorage.setItem(tableSizeSaveKey,tableSize);
}

return (<>

  <ModalNegociacion 
  {...configModalNegociacion}
   cancelOption={e=>setConfigModalNegociacion({})}
  />

  <ObserVacionesDialogComponent />
  <ConfirmacionParcialDialogComponent />

  <Grid container spacing={2} >
        <Grid item sm={10} xs={10} md={10} >
          {
            Object.keys(productoInfo).length > 0 && <FilterForm
            key={`${productoInfo.necesidad_total}-${productoInfo.total_comprado}-${productoInfo.necesidad_pendiente}`}
            ref={formRef}
            nameFilter=""
            hideButtoms={true}
            inputsFilter={InputFilters}
            schemaValidator={schemaFilter}
            initialValuesFilter={
             {...productoInfo}
            }
            onApplyFilter={()=>{}}
          />
          }
        </Grid>
        <Grid  item sm={2} xs={2} md={2} >
          
          <TextField 
          onChange={e=>setTableSize(e.target.value)}
          type="number"
         value={tableSize}
          InputProps={{
           endAdornment:<IconButton onClick={saveScreenSize} ><Save /></IconButton>
          }} variant="standard"  sx={{alignSelf:"center",marginTop:"20px"}}  size="small" label='tamaño de la tabla' />
         </Grid>
    <Grid item sm={4} xs={4} md={4} >
       <Button variant="contained" color="primary" onClick={ConfirmarOrdenesCompra} >Preconfirmar ordenes</Button> 
       <Button variant="contained" color="secondary" sx={{marginLeft:'6px'}} onClick={e=>navigation(-1)} >Regresar</Button> 
    </Grid>
  
    <Grid item sm={12} xs={12} md={12} >

      <TableContainer sx={{ maxHeight:tableSize+'px'}} >
        <Table border={1} stickyHeader >
          <TableHead>
            <TableRow>

              {
                columnsTable.map(colum => <TableCell key={colum.key} >
                  {colum.headerRender(colum)}
                </TableCell>)
              }

            </TableRow>

          </TableHead>
          <TableBody>

            {dataSetProdctos.map((prod,prod_index) =>
              <TableRow key={prod.cotizacion_cod}  >

                {
                  columnsTable.map(Col =>
                    <TableCell key={Col.key + "-" + prod.cod} >
                      {Col.bodyRender({
                        principal_index: prod_index,
                        item_index: prod_index,
                        item: {...prod},
                        value: prod[Col.keyValue]
                      })}
                    </TableCell>)
                }

              </TableRow>
            )}

          </TableBody>

        </Table>
      </TableContainer>


    </Grid>
  </Grid>
</>)

}